import api from './index.js'

export const fetchHelpCenterTemplates = async (
  currentPage,
  pageSize,
  params,
  sortColumn,
  sortDirection
) => {
  try {
    const queryParams = new URLSearchParams(params).toString() // Convert params object to query string
    const response = await api.get(
      `/admin/help-center-template?pageNumber=${currentPage}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&${queryParams}`
    )

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to fetch help-center-templates')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to fetch help-center-templates')
  }
}
export const fetchHelpCenterTemplate = async id => {
  try {
    const response = await api.get(`/admin/help-center-template/${id}`)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to fetch help-center-template')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to fetch help-center-template')
  }
}

export const updateHelpCenterTemplate = async (id, helpData) => {
  try {
    const response = await api.put(`/admin/help-center-template/${id}`, helpData)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to update help-center-template')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to update help-center-template')
  }
}

export const createHelpCenterTemplate = async helpData => {
  try {
    const response = await api.post('/admin/help-center-template', helpData)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to create help-center-template')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to create help-center-template')
  }
}

export const deleteHelpCenterTemplate = async id => {
  try {
    const response = await api.delete(`/admin/help-center-template/${id}`)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to delete help-center-template')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to delete help-center-template')
  }
}
